import { conciliationInitAxios } from '../config/axiosInstances';
import {
  ParametricStore,
  CreateParametricStoreRequest,
  UpdateParametricStoreRequest,
} from '../state/parametricStores/types';

export default class ParametricStoresApi {
  static async list(country: string) {
    return conciliationInitAxios.get<ParametricStore[]>('/parametric-stores', {
      params: { country },
    });
  }

  static async create(data: CreateParametricStoreRequest) {
    return conciliationInitAxios.post<ParametricStore>('/parametric-stores', data);
  }

  static async update(code: string, country: string, data: UpdateParametricStoreRequest) {
    return conciliationInitAxios.put<void>(`/parametric-stores/${code}`, data, {
      params: { country },
    });
  }

  static async remove(code: string, country: string) {
    return conciliationInitAxios.delete<void>(`/parametric-stores/${code}`, {
      params: { country },
    });
  }
}
